import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const testimonials = [{
  id: 1,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/m5sfRGr7jVsWjdfz8AyX7X/Agregar_un_titulo_(7).png',
  alt: 'Testimonio de Andrés V.'
}, {
  id: 2,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/iUwySpA9eDoBjrn5U2vZ7w/Agregar_un_titulo_(8).png',
  alt: 'Testimonio de Carmen Suárez'
}, {
  id: 3,
  type: 'video',
  src: 'https://cdn.magicpatterns.com/uploads/2pFVbA4TrC41QAa856QgMt/Testimonio%201.MOV'
}, {
  id: 4,
  type: 'video',
  src: 'https://cdn.magicpatterns.com/uploads/i8X1QF8rSWBxTjtJzTBU4A/Testimonio%202.MOV'
}, {
  id: 5,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/3B2kQAtJ1rTSQUjFneBwS2/Agregar_un_titulo_(7).png',
  alt: 'Testimonio de cliente'
}];
export function Testimonials() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const goTo = (next: number) => {
    setDirection(next > index ? 1 : -1);
    setIndex((next + testimonials.length) % testimonials.length);
  };
  const next = () => goTo(index + 1);
  const prev = () => goTo(index - 1);
  const current = testimonials[index];
  const slideVariants = {
    enter: (dir: number) => ({
      opacity: 0,
      x: dir > 0 ? 100 : -100
    }),
    center: {
      opacity: 1,
      x: 0
    },
    exit: (dir: number) => ({
      opacity: 0,
      x: dir > 0 ? -100 : 100
    })
  };
  return <section className="py-24 md:py-32 bg-ink-light relative overflow-hidden" data-id="element-196">
      <div className="container mx-auto px-6" data-id="element-197">
        <motion.div className="text-center max-w-2xl mx-auto mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-198">
          <h2 className="text-3xl md:text-5xl font-serif text-ivory-bright mb-6" data-id="element-199">
            Personas que decidieron volver a sí mismas
          </h2>
          <p className="text-muted font-light text-lg" data-id="element-200">
            No necesitas seguir cargando todo en silencio. Aquí comparto algunas
            experiencias de personas que comenzaron su proceso de reconstrucción
            emocional.
          </p>
        </motion.div>

        <div className="relative max-w-sm md:max-w-md mx-auto" data-id="element-201">
          {/* Carousel Viewport */}
          <div className="relative overflow-hidden rounded-2xl bg-black/40 border border-white/10 h-[550px] md:h-[650px] flex items-center justify-center shadow-2xl" data-id="element-202">
            <AnimatePresence mode="wait" custom={direction} data-id="element-203">
              <motion.div key={current.id} custom={direction} variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
              duration: 0.5,
              ease: [0.16, 1, 0.3, 1]
            }} className="absolute inset-0 flex items-center justify-center p-2 md:p-4" data-id="element-204">
                {current.type === 'image' ? <img src={current.src} alt={current.alt} className="w-full h-full object-contain drop-shadow-lg" data-id="element-205" /> : <video src={current.src} className="w-full h-full object-contain drop-shadow-lg" autoPlay muted loop playsInline controls data-id="element-206" />}
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Navigation Arrows */}
          <button onClick={prev} aria-label="Testimonio anterior" className="absolute left-0 -translate-x-4 md:-translate-x-16 top-1/2 -translate-y-1/2 z-10 w-12 h-12 flex items-center justify-center bg-ink border border-gold/30 text-gold hover:bg-gold hover:text-ink transition-colors duration-300 rounded-full shadow-lg" data-id="element-207">
            <ChevronLeft className="w-6 h-6" data-id="element-208" />
          </button>
          <button onClick={next} aria-label="Siguiente testimonio" className="absolute right-0 translate-x-4 md:translate-x-16 top-1/2 -translate-y-1/2 z-10 w-12 h-12 flex items-center justify-center bg-ink border border-gold/30 text-gold hover:bg-gold hover:text-ink transition-colors duration-300 rounded-full shadow-lg" data-id="element-209">
            <ChevronRight className="w-6 h-6" data-id="element-210" />
          </button>

          {/* Dots Indicators */}
          <div className="flex items-center justify-center gap-3 mt-8" data-id="element-211">
            {testimonials.map((t, i) => <button key={t.id} onClick={() => goTo(i)} aria-label={`Ver testimonio ${i + 1}`} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${i === index ? 'bg-gold scale-125' : 'bg-white/20 hover:bg-white/40'}`} data-id="element-212" />)}
          </div>
        </div>
      </div>
    </section>;
}